// removed by extract-text-webpack-plugin
module.exports = {"masterPageHeader":"_2p-PPxLHeN821yPa6SecxD"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardMasterPageHeader.scss
// module id = 1492
// module chunks = 0